import { z } from 'zod';

import { managementInstance } from '../../../i18n';

export const invitationSchema = z.object({
    customerIdentifier: z
        .string()
        .min(1, managementInstance.t('isRequired', { label: managementInstance.t('customerNumber') })),
    companyName: z.string().min(1, managementInstance.t('isRequired', { label: managementInstance.t('companyName') })),
    companyRegistrarEmail: z
        .email(managementInstance.t('notValidMail'))
        .min(1, managementInstance.t('isRequired', { label: managementInstance.t('companyRegistrarEmail') })),
    companyRegistrarFirstName: z.string().optional(),
    companyRegistrarLastName: z.string().optional(),
    invitationLanguage: z.string().optional(),
});

export type InvitationFormValues = z.infer<typeof invitationSchema>;
